import { mapActions, mapState } from 'vuex'
import LogoAxoft from "@assets/img/LogoAxoft.svg?inline"
import VK from "@assets/lk/img/VK.svg?inline"
import VC from "@assets/lk/img/VC.svg?inline"
import TG from "@assets/lk/img/TG.svg?inline"

export default {
    components: {
        'logo-axoft-svg': LogoAxoft,
        'lk-vk-svg': VK,
        'lk-vc-svg': VC,
        'lk-telegram-svg': TG,
    },
    data() {
        return {}
    },
    computed: {
        ...mapState('mobile', ['isTablet']),
    },
    methods: {
        ...mapActions('modal', ['modalType_collabOpen', 'modalClose'])
    }
};



// WEBPACK FOOTER //
// ./src/templates/components/base/footer/component.js